module.exports = __webpack_public_path__ + "static/media/goddess.0ca639c0.jpg";